export default {
  state: {
    dateInicio: '',
    dateFin: '',
    filterSelected: '',
    filterConvenioSelected: null,
    filterEstadoGarantiaSelected: null,
    filterCedula: '',
    filterPagare: '',
    filterCaseNumber: '',
    filterCaseName: '',
    filterModelosSelected: null,
    filterTipoArchivoSelected: null,
    nRows: 10
  },
  getters: {
    dateInicio: state => state.dateInicio,
    dateFin: state => state.dateFin,
    filterSelected: state => state.filterSelected,
    filterConvenioSelected: state => state.filterConvenioSelected,
    filterEstadoGarantiaSelected: state => state.filterEstadoGarantiaSelected,
    filterCedula: state => state.filterCedula,
    filterPagare: state => state.filterPagare,
    filterCaseNumber: state => state.filterCaseNumber,
    filterCaseName: state => state.filterCaseName,
    filterModelosSelected: state => state.filterModelosSelected,
    filterTipoArchivoSelected: state => state.filterTipoArchivoSelected,
    nRows: state => state.nRows
  },
  mutations: {
    setDateInicio: (state, payload) => (state.dateInicio = payload),
    setDateFin: (state, payload) => (state.dateFin = payload),
    setFilterSelected: (state, payload) => (state.filterSelected = payload),
    setFilterConvenioSelected: (state, payload) =>
      (state.filterConvenioSelected = payload),
    setFilterEstadoGarantiaSelected: (state, payload) =>
      (state.filterEstadoGarantiaSelected = payload),
    setFilterCedula: (state, payload) => (state.filterCedula = payload),
    setFilterPagare: (state, payload) => (state.filterPagare = payload),
    setFilterCaseNumber: (state, payload) => (state.filterCaseNumber = payload),
    setFilterCaseName: (state, payload) => (state.filterCaseName = payload),
    setFilterModelosSelected: (state, payload) =>
      (state.filterModelosSelected = payload),
    setFilterTipoArchivoSelected: (state, payload) => {
      state.filterTipoArchivoSelected = payload
    },
    setnRows: (state, payload) => (state.nRows = payload),
    setClear: (state) => (
      (state.dateInicio = null),
      (state.dateFin = null),
      (state.filterSelected = null),
      state.filterConvenioSelected = null,
      state.filterEstadoGarantiaSelected = null,
      state.filterCedula = null,
      state.filterPagare = null,
      state.filterCaseNumber = null,
      state.filterCaseName = null,
      state.filterModelosSelected = null,
      (state.nRows = 10)
    )
  }
}
